export const fetchFiduciaryData = resp => {
  return {
    type: "FETCH_FIDUCIARY",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/fiduciary.js